import { Box, Typography } from '@mui/material';
import React from 'react';
import { sxConfig } from './calendarStyle';

const TooltipContent = ({ eventInfo }) => {
  const task = eventInfo?.event?.extendedProps;

  return (
    <Box>
      <Box sx={sxConfig.tooltipContent}>
        <Typography sx={sxConfig.tooltipContentFirstTyp}>Megjegyzés:</Typography>
        <Typography>{task.description}</Typography>
      </Box>
    </Box>
  );
};

export default TooltipContent;
